import useSWR from 'swr';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

export type DashboardSummary = {
  mtdRevenue: number;
  openBalance: number;
  lateFees: number;
  expenses: number;
  monthlyRevenue: number[];
  agingBuckets: number[];
};

export function useDashboardSummary() {
  const { token, currentBusiness, isCookieMode, API_BASE_URL, isBusinessSessionSynced } = useAuth();

  const fetcher = async ([url, businessId]: [string, string]) => {
    // Use the environment variable to construct the full API URL
    const fullUrl = `${API_BASE_URL}${url}`;
    console.log('Dashboard API call:', { 
      url, 
      fullUrl, 
      businessId, 
      token: token ? 'present' : 'missing', 
      isCookieMode,
      API_BASE_URL 
    });
    
    const headers: any = { };
    
    // Only add Authorization header if not in cookie mode
    if (!isCookieMode && token) {
      headers.Authorization = `Bearer ${token}`;
    }
    
    const response = await axios.get(fullUrl, {
      headers,
      withCredentials: isCookieMode, // This sends cookies with the request
    });
    
    console.log('Dashboard API response:', response.data);
    return response.data;
  };

  const { data, error, isLoading } = useSWR<DashboardSummary>(
    currentBusiness && isBusinessSessionSynced ? ['/dashboard/summary', currentBusiness.id] : null,
    fetcher
  );
  
  console.log('Dashboard hook state:', { data, error, isLoading, currentBusiness: currentBusiness?.id });
  
  return {
    data,
    error,
    isLoading,
  };
} 